<dashboardnav>
  <cradua-cabinet-shelf-ref
    [fiscalfilelocations]="fiscalfilelocations$ | async"
    [cabinetshelfref]="cabinetshelfref$ | async"
    (changeEmit)="onSubmitCabinetShelfRef($event)"
    (deleteEvent)="onDeleteCabinetShelfRef($event)"
    *ngIf="
      !(isLoadingFiscalFileLocation$ | async) &&
      !(isLoadingCabinetShelfRef$ | async)
    "
  >
  </cradua-cabinet-shelf-ref>

  <mrsoftapps-epims-reference-spinner
    *ngIf="
      (isLoadingFiscalFileLocation$ | async) ||
      (isLoadingCabinetShelfRef$ | async)
    "
  >
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
